import { useMemo } from 'react';
import { useUtils } from '../../../../context/UtilsContext';

/** Event type for user profile / plan assignment APIs. */
export function useProfileEventTypeId() {
  const { sessionUtils } = useUtils();
  return useMemo(
    () =>
      sessionUtils?.event_types?.[0]?.event_types?.find(
        (x) => x.description === 'get_user_profile_details'
      )?.id,
    [sessionUtils]
  );
}
